import { useMemo, useState } from 'react';

import { BaseInputBasic } from '..';
import { debounce } from '../../helpers/common.helpers';
import AppConfig from '../../providers/AppConfig';

export const BaseSearch = (props) => {
  const { onChange, placeholder, ...rest } = props;
  const [search, setSearch] = useState('');

  const debouncedChange = useMemo(
    () => debounce((e) => onChange(e), AppConfig.searchDebounceTime),
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <BaseInputBasic
      placeholder={placeholder}
      icon="search"
      handleChange={(e) => {
        debouncedChange(e);
        setSearch(e);
      }}
      value={search}
      deletable
      data-testid={rest['data-testid']}
    />
  );
};

export default BaseSearch;
